// extracted by mini-css-extract-plugin
export default {"container":"CZ-z","list":"DZ-z"};